<template>
    <div class="score-icon">
        <div
            class="icon-item"
            v-for="(item, index) in 5"
            :key="index"
            :style="{
                background: index === 0 ? 'rgba(34, 64, 195, 1)' : '',
                color: index === 0 ? '#fff' : '',
            }"
        >
            {{ item }}
        </div>
    </div>
</template>
<style lang="scss" scoped>
.score-icon {
    display: flex;
    .icon-item {
        width: 22px;
        height: 22px;
        line-height: 19px;
        text-align: center;
        margin-right: 10px;
        border: 1px solid rgba(228, 229, 232, 1);
        color: rgba(102, 102, 102, 1);
        font-weight: 400;
        font-size: 11px;
    }
}
</style>
